// src/PrivacyPolicy.js
import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900 p-6">
      <div className="max-w-3xl w-full bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-4xl font-bold text-center text-orange-600 mb-10">Privacy Policy for Wallpaper App</h1>
        {/* Uncomment and set the date */}
        {/* <p className="text-sm text-gray-500 text-center mb-4">Last updated: [Date]</p> */}

        <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Introduction</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            Wallpaper App is committed to protecting your privacy. This Privacy Policy explains how we handle your information when you use our mobile application and services.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Information We Collect</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            We do not collect any personal information. Our app may request access to your camera to allow you to:
          </p>
          <ul className="list-disc list-inside mb-4 text-gray-700">
            <li><strong>Download Images:</strong> You may download images for personal use.</li>
            <li><strong>Share Images:</strong> You can share images directly from the app to other applications.</li>
          </ul>
        </section>

        <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Use of Your Information</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            The app uses camera access solely for the following purposes:
          </p>
          <ul className="list-disc list-inside mb-4 text-gray-700">
            <li>To enable you to download pictures or use the downloaded pictures as wallpapers.</li>
            <li>To facilitate sharing of images to your preferred applications.</li>
          </ul>
        </section>

        <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Security of Your Information</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            While we do not collect or store your personal information, we take reasonable measures to protect any information that may be temporarily stored in your device.
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Changes to This Privacy Policy</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>

        {/* Uncomment the Contact Us section if needed */}
        {/* <section className="mt-6">
          <h2 className="text-3xl font-semibold mb-3 text-gray-800 border-b-2 border-gray-300 pb-2">Contact Us</h2>
          <p className="text-gray-700 mb-4 leading-relaxed">
            If you have any questions about this Privacy Policy, please contact us at:
            <br />
            [Your Contact Email]
          </p>
        </section> */}
      </div>
    </div>
  );
};

export default PrivacyPage;
